export default {"src":"/_next/static/media/arrow-right-to-bracket-solid.3cbb25d0.svg","height":512,"width":512};